module.exports = __webpack_public_path__ + "static/media/CIA.9b33ac03.jpg";